import {httpGet,httpPut,httpDelete,httpPost,httpPostForm,httpDownload} from '@/util/request.js';
import appConfig from '@/config';

export default class BudgetMatterApi{

    static QUERY_BUDGET_MATTER_LIST = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-wb-budget-matter/list";
    static BUDGET_MATTER_IMPORT_DATA = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-wb-budget-matter/importData";
    static BUDGET_MATTER_EXPORT_DATA = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-wb-budget-matter/exportData";
    static BUDGET_MATTER_IMPORT_TEMPLATE = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-wb-budget-matter/importTemplate";
    static QUERY_BUDGET_MATTER_DETAIL = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-wb-budget-matter/get";
    static BUDGET_MATTER_EDIT = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-wb-budget-matter/edit";
    static BUDGET_MATTER_DISABLE = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-wb-budget-matter/disable";
    static BUDGET_MATTER_ENABLE = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-wb-budget-matter/enable";

	static QUERY_SUBJECT_LIST = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-wb-budget-matter/subject/list";
	static QUERY_TYPE_LIST = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-wb-budget-matter/type/list";
	static QUERY_EDITION_LIST = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-wb-budget-matter/edition/list";

    static list(params){
		return httpGet(BudgetMatterApi.QUERY_BUDGET_MATTER_LIST,params);
    }
    static listSubject(params){
		return httpGet(BudgetMatterApi.QUERY_SUBJECT_LIST,params);
    }
    static listBudgetType(params){
		return httpGet(BudgetMatterApi.QUERY_TYPE_LIST,params);
    }
    static listEdition(params){
		return httpGet(BudgetMatterApi.QUERY_EDITION_LIST,params);
    }

    static importData(file){
		let formData = new FormData()
		formData.append('file', file);
		return httpPost(BudgetMatterApi.BUDGET_MATTER_IMPORT_DATA,formData);
    }

    static exportData(params){
		return httpDownload(BudgetMatterApi.BUDGET_MATTER_EXPORT_DATA,params);
    }

    static importTemplate(params){
		return httpDownload(BudgetMatterApi.BUDGET_MATTER_IMPORT_TEMPLATE,params);
    }

    static detail(params){
      return httpGet(BudgetMatterApi.QUERY_BUDGET_MATTER_DETAIL,params);
    }

    static edit(params){
		return httpPut(BudgetMatterApi.BUDGET_MATTER_EDIT,params);
    }

	static disable(params){
		return httpPut(BudgetMatterApi.BUDGET_MATTER_DISABLE,params);
    }

	static enable(params){
		return httpPut(BudgetMatterApi.BUDGET_MATTER_ENABLE,params);
    }

}